import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center mb-4 group">
              <img
                src="/logo/logo-full-white.png"
                alt="AP Digital Hub - 🇨🇦 Canada's Elite Digital Marketing Collective"
                loading="lazy"
                decoding="async"
                className="h-10 w-auto object-contain transition-all duration-300 group-hover:scale-105"
              />
            </Link>
            <p className="text-gray-400 mb-3 leading-relaxed">
              🇨🇦 Canada's premier digital performance engine. We transform ambitious brands through data-driven planning and elite execution.
            </p>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-white/5 border border-white/10 px-3 py-1.5 text-xs text-gray-400 mb-6">
              <span aria-hidden="true">🇨🇦</span>
              <span aria-hidden="true">🇺🇸</span>
              <span className="whitespace-nowrap">Serving clients in Canada & US</span>
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com/codewitharjun" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://twitter.com/codewitharjun" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition duration-200">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://instagram.com/codewitharjun" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition duration-200">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com/in/codewitharjun" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition duration-200">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://www.youtube.com/@CodeWithArjun" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-primary-400 transition duration-200">
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white uppercase tracking-wider text-sm">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services/search-engine-optimization" className="text-gray-400 hover:text-white transition duration-200">Search Engine Optimization</Link></li>
              <li><Link to="/services/social-media-marketing" className="text-gray-400 hover:text-white transition duration-200">Social Media Marketing</Link></li>
              <li><Link to="/services/video-content-production" className="text-gray-400 hover:text-white transition duration-200">Video Content Production</Link></li>
              <li><Link to="/services/content-marketing" className="text-gray-400 hover:text-white transition duration-200">Content Marketing</Link></li>
              <li><Link to="/services/analytics-and-reporting" className="text-gray-400 hover:text-white transition duration-200">Analytics & Reporting</Link></li>
              <li><Link to="/services/web-development" className="text-gray-400 hover:text-white transition duration-200">Web Development</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white uppercase tracking-wider text-sm">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition duration-200">About Us</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-white transition duration-200">Portfolio</Link></li>
              <li><Link to="/portfolio" className="text-gray-400 hover:text-white transition duration-200">Success Stories</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition duration-200">Blog & Insights</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition duration-200">Careers</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition duration-200">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white uppercase tracking-wider text-sm">Contact Info</h3>
            <div className="space-y-3 text-gray-400">
              <p className="flex flex-col">
                <span className="text-white font-medium">Headquarters</span>
                50 Pennyroyal Crescent, Brampton, ON M3H 5P8, 🇨🇦 Canada
              </p>
              <p className="pt-2">
                <a href="tel:+14376012079" className="hover:text-white transition duration-200 flex items-center gap-2">
                  <span className="text-primary-400">P:</span> +1 (437) 601-2079
                </a>
              </p>
              <p>
                <a href="mailto:contact@apdigitalhub.com" className="hover:text-white transition duration-200 flex items-center gap-2">
                  <span className="text-primary-400">E:</span> contact@apdigitalhub.com
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/[0.05] mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} APDigitalHub. Built for high performance.
            </p>
            <div className="flex space-x-8">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-white text-xs transition duration-200">Privacy Policy</Link>
              <Link to="/terms-of-service" className="text-gray-500 hover:text-white text-xs transition duration-200">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;